import React, { useEffect, useState } from "react";
import api from "../../api/axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Save, ArrowLeft } from "lucide-react";

function CreateUser() {
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);
  const [clients, setClients] = useState([]);
  const [isSavingAndContinuing, setIsSavingAndContinuing] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    role_id: "",
    client_id: "",
  });

  const fetchRoles = async () => {
    try {
      const response = await api.get("/roles");
      setRoles(Array.isArray(response.data) ? response.data : response.data.roles || []);
    } catch (error) {
      console.error("Error al cargar los roles", error);
      toast.error("Error al cargar los roles");
    }
  };

  const fetchClients = async () => {
    try {
      const response = await api.get("/clients");
      setClients(
        Array.isArray(response.data)
          ? response.data
          : response.data.clients || []
      );
    } catch (error) {
      console.error("Error al cargar las áreas", error);
      toast.error("Error al cargar las áreas");
    }
  };

  useEffect(() => {
    fetchRoles();
    fetchClients();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/users", formData);
      console.log("Éxito: usuario creado");
      toast.success("Usuario creado exitosamente");

      if (isSavingAndContinuing) {
        setFormData({
          name: "",
          email: "",
          password: "",
          role_id: "",
          client_id: "",
        });
        setIsSavingAndContinuing(false);
      } else {
        navigate("/users");
      }
    } catch (error) {
      toast.error("Error al crear el usuario");
      console.error(error);
    }
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow-md max-w-xl mx-auto">
      <button
        onClick={() => navigate("/users")}
        className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6"
      >
        <ArrowLeft size={20} />
        Volver a usuarios
      </button>

      <h2 className="text-3xl font-semibold text-gray-800 mb-6">
        Crear Usuario
      </h2>

      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Nombre
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Nombre del usuario"
            required
            className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Email
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Correo electrónico"
            required
            className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Contraseña
          </label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="Contraseña"
            required
            className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Rol
          </label>
          <select
            name="role_id"
            value={formData.role_id}
            onChange={handleChange}
            required
            className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Seleccionar rol</option>
            {roles.map((role) => (
              <option key={role.id} value={role.id}>
                {role.name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Área
          </label>

          <select
            name="client_id"
            value={formData.client_id}
            onChange={handleChange}
            className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Sin área</option>

            {clients.map((client) => (
              <option key={client.id} value={client.id}>
                {client.name}
              </option>
            ))}
          </select>
        </div>

        <div className="flex gap-4">
          <button
            type="submit"
            onClick={() => setIsSavingAndContinuing(false)}
            className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-lg shadow transition duration-300"
          >
            <Save size={18} />
            Crear
          </button>

          <button
            type="submit"
            onClick={() => setIsSavingAndContinuing(true)}
            className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-lg shadow transition duration-300"
          >
            <Save size={18} />
            Crear y seguir
          </button>
        </div>
      </form>
    </div>
  );
}

export default CreateUser;
